import { render, staticRenderFns } from "./DepotModal.vue?vue&type=template&id=1a3dbb37&scoped=true"
import script from "./DepotModal.vue?vue&type=script&lang=js"
export * from "./DepotModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3dbb37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a3dbb37')) {
      api.createRecord('1a3dbb37', component.options)
    } else {
      api.reload('1a3dbb37', component.options)
    }
    module.hot.accept("./DepotModal.vue?vue&type=template&id=1a3dbb37&scoped=true", function () {
      api.rerender('1a3dbb37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DepotModal.vue"
export default component.exports